import React from 'react';

const ConsultancyBanner = () => {
  return (
    <section
      className="h-[55vh] sm:h-[70vh] md:h-[90vh] lg:h-[92vh] bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: "url('/images/deta-refined-1.webp')"
      }}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
      />
      
      {/* Banner Content */}
      <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
        <div className="text-left text-white max-w-2xl ml-0 sm:ml-8 md:ml-24 lg:ml-48 xl:ml-72">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 leading-tight">
            Data, <span style={{ color: '#db0058' }}>redefined.</span>
          </h1>
          <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8 leading-relaxed max-w-xs sm:max-w-none">
            We're on a mission to supply the very best consumer data, add value to existing data, and deliver customer insight that drives performance and growth.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ConsultancyBanner;